export default "__VITE_ASSET__tOcgWiQG__"